var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-full left-0"},[_vm._v("\n  "+_vm._s(_vm.old)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }